import React from 'react'

const Stats = () => {
  return (
    <>
      <div className="stats-container datatalent-section-gap">
        <div className="container">
          <div className="row g-5">
            <div className="col-12 col-lg-4 mt-0 px-0 px-md-4">
              <div className="stats-card d-flex flex-column align-items-center justify-content-center gap-2 p-4">
                <h2 className="color-white lh-1 mb-0">300+</h2>
                <p className="color-white mb-0">AI Projects Delivered</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 mt-4 mt-md-0 px-0 px-md-4">
              <div className="stats-card d-flex flex-column align-items-center justify-content-center gap-2 p-4">
                <h2 className="color-white lh-1 mb-0">40K+</h2>
                <p className="color-white mb-0">Course Enrollments</p>
              </div>
            </div>
            <div className="col-12 col-lg-4 mt-4 mt-md-0 px-0 px-md-4">
              <div className="stats-card d-flex flex-column align-items-center justify-content-center gap-2 p-4">
                <h2 className="color-white lh-1 mb-0">100+</h2>
                <p className="color-white mb-0">Clients & Industry Partners</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Stats;